import eventBus from "@/utils/eventBus.js";

export default function (defaultData = null, immediately = true) {
  return {
    data() {
      return {
        isLoading: true,
        data: defaultData,
        search: {},
        footer: {},
        selection: [],
      };
    },
    created() {
      if (immediately) {
        this.getData();
      } else {
        this.isLoading = false;
      }
    },
    methods: {
      async getData() {
        this.isLoading = true;
        let res = await this.requst({ ...this.search, ...this.footer });
        if (res) {
          this.data = res;
        }
        this.isLoading = false;
      },
      getPage(data) {
        this.footer = data;
        this.getData();
      },
      searchData(data) {
        this.search = JSON.parse(JSON.stringify(data));
        this.footer.pageNumber = 1;
        eventBus.$emit("footPage-Change", 1);
        const { sendType, date } = data;
        if (sendType && sendType.length > 0) {
          this.search.sendType = sendType.join(",");
        }
        if (date && date.length > 0) {
          this.search.startSendTime = date[0];
          this.search.endSendTime = date[1];
          delete this.search.date;
        }
        this.getData();
      },
      selectChange(data) {
        this.selection = data.map((item) => {
          return item.id;
        });
      },
      sortChange(rule) {
        const { order, prop } = rule;
        let getData = (time) => new Date(time).getTime();
        if (order) {
          if (order === "ascending") {
            this.data.sendList.sort(
              (a, b) => getData(a[prop]) - getData(b[prop])
            );
          } else {
            this.data.sendList.sort(
              (a, b) => getData(b[prop]) - getData(a[prop])
            );
          }
        } else {
          let key = this.tableData.headConfig.selectProp;
          this.data.sendList.sort((a, b) => getData(b[key]) - getData(a[key]));
        }
      },
    },
  };
}
